module.exports = __webpack_public_path__ + "media/components/assets/img/pic/map-77959c58af64c4ac73d6287bd884d546.jpg";